module.exports = __webpack_public_path__ + "img/bil.1a4105dd.jpg";